<template>
  <div class="notifications fixed">
    <transition-group name="fade-in-down">
      <div
        v-for="(notification, index) in notifications"
        :key="`${notification.type}_${index}`"
        class="notification c-bg-grayscale-lighter"
        :class="`c-brdr-${notification.type} brdr-2 ${notification.type}`"
      >
        <div class="heading flex c-black semi-bold uppercase lh16">
          <i :class="`icon icon-${notification.type} c-${notification.type} fs16 mr10`" /> {{ heading(notification) }}
        </div>
        <div
          class="fs14 lh20 my5 mt10-desktop mb10-desktop"
          data-testid="notificationMessage"
          @click="execAction(notification.action1, index)"
        >
          {{ notification.message }}
        </div>
        <div class="actions flex between-xs">
          <button-full
            id="notificationAction1"
            class="mr5 mr10-desktop w-100"
            :class="notification.type"
            data-testid="notificationAction1"
            @click.native="execAction(notification.action1, index)"
          >
            {{ notification.action1.label }}
          </button-full>
          <button-full
            v-if="notification.action2"
            id="notificationAction2"
            class="w-100 button-cancel"
            data-testid="notificationAction2"
            @click.native="execAction(notification.action2, index)"
          >
            {{ notification.action2.label }}
          </button-full>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import ButtonFull from 'theme/components/theme/ButtonFull';
import { Notification } from '@vue-storefront/core/modules/notification/components/Notification'

export default {
  components: {
    ButtonFull
  },
  mixins: [Notification],
  methods: {
    heading (notification) {
      return notification.title || this.$t(notification.type)
    },
    execAction (action, index) {
      if (action.action) {
        // for backward compatibility
        if (action.action === 'close') {
          this.$store.dispatch('notification/removeNotification', index)
        } else {
          action.action()
        }
      }
      this.$store.dispatch('notification/removeNotification', index)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/variables/grid';
@import '~theme/css/variables/components';
@import '~theme/css/helpers/mixins';

$z-index-notification: map-get($z-index, notification);
$color-error: color(error);
$color-success: color(success);
$color-warning: color(warning);
$color-info: color(info);

.notifications {
  top: 100px;
  right: 5%;
  width: 400px;
  z-index: $z-index-notification;

  @include mobile {
    width: auto;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;

    .fade-in-down-enter,
    .fade-in-down-leave-to {
      transform: translateY(100%);
    }
  }
}

.notification {
  padding: 13px;

  @include desktop {
    padding: 18px;
  }

  .button {
    font-size: 12px;
    line-height: 14px;
    padding: 11px 20px;

    @include desktop {
      font-size: 14px;
      line-height: 16px;
      padding: 15px 30px;
    }
  }
}

.heading {
  @include desktop {
    line-height: 18px;
  }
}

.actions {
  #notificationAction1 {
    color: color(white);

    &.info {
      background-color: $color-info;

      @include hover(background-color, rgba($color-info, 0.9));
    }

    &.warning {
      background-color: $color-warning;

      @include hover(background-color, color(primary-hover));
    }

    &.success {
      background-color: $color-success;

      @include hover(background-color, rgba($color-success, 0.9));
    }

    &.error {
      background-color: $color-error;

      @include hover(background-color, darken($color-error, 2%));
    }
  }
}
</style>
